'use strict';

var _ = require('lodash');
function FlightManagementModePanelController($scope, $rootScope, $q, constants, applicableSeasonsLoadingService, reoptPreviewDataUtilsService, reoptimizationService, dataRetrieverConstants, profileChartUrdSettingProviderService, dataService) {
  $scope.selectedFlights = [];
  $scope.isModalChartEnabled = false;
  $scope.reoptPreviewData = {
    flightDetails: {},
    mode: 'Flight Management'
  };
  var selectFlights = _.throttle(function (selectedFlights) {
    $scope.selectedFlights = selectedFlights;
    $scope.initializeComponents(selectedFlights);
  }, 200);
  $scope.showProfileChart = function () {
    var selectedFlight = _.first($scope.selectedFlights);
    $rootScope.$broadcast('profile-chart-panel:swap', true, {
      screen: $scope.screen,
      screenMode: dataRetrieverConstants.FLIGHT_MANAGEMENT_MODE,
      selectedMetric: {
        id: 'booking',
        label: 'Bookings',
        chartType: 'profile-chart'
      },
      primaryEntity: selectedFlight,
      selectedService: selectedFlight,
      target: 'flight-profile-chart',
      mode: 'cabin',
      subMode: 'flight-cabin-profile-mode',
      legendFilter: profileChartUrdSettingProviderService.getUrdFilter($scope.screen, 'cabin')
    });
  };
  $scope.onFlightSummaryRowSelectionChanged = function (event, selectedRows, gridId, allRows, selectedRowIndexes, selectionFilters, visibleRowProperties) {
    if (gridId !== constants.GRIDS.FLIGHT_SUMMARY) {
      return;
    }
    if (reoptPreviewDataUtilsService.isMdReopt($scope.reoptPreviewData) || reoptPreviewDataUtilsService.isNdReopt($scope.reoptPreviewData)) {
      reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    }
    $scope.isModalChartEnabled = selectedRows.length === 1;
    if ($scope.isModalChartEnabled) {
      $scope.resetProfileChartSelectedMetric();
    }
    reoptPreviewDataUtilsService.updateFlightDetails($scope.reoptPreviewData, {
      gridId: gridId,
      jqxGridSettings: {
        source: {
          loadedData: allRows || []
        }
      }
    }, selectedRows);
    selectFlights(selectedRows);
    $scope.screenState.profileChartPanel.contextData = _.assign($scope.screenState.profileChartPanel.contextData, {
      visibleRowProperties: _.cloneDeep(visibleRowProperties),
      selectedRowIndexes: _.cloneDeep(selectedRowIndexes)
    });
  };
  $scope.initializeComponents = function (selectedFlights) {
    applicableSeasonsLoadingService.loadApplicableSeasons(_.get(selectedFlights, '[0].leg'), 'FLIGHT_SCREEN');
    return selectedFlights;
  };
  $scope.$on('reoptimizeGrid', function (ev, gridId, selectedRows) {
    reoptimizationService.reoptimizeFromFlightScreen(selectedRows, 'PUBLISHED');
  });
  $scope.populateOverridesToScreenState = function (event, overridesData) {
    $scope.screenState.flightManagementMode.overrides = overridesData;
  };
  $scope.clearUserOverridesFromScreenState = function (newValue) {
    if (newValue === true) {
      $scope.screenState.flightManagementMode.overrides = null;
    }
  };
  $scope.$on('search-criteria:searchChangeEvent', function () {
    dataService.clearCache();
  });
}
FlightManagementModePanelController.$inject = ['$scope', '$rootScope', '$q', 'FlightManagementConstants', 'ApplicableSeasonsLoadingService', 'ReoptPreviewDataUtilsService', 'ReoptimizationService', 'DataRetrieverConstantsService', 'ProfileChartUrdSettingProviderService', 'DataService'];
module.exports = FlightManagementModePanelController;